<div class="grid">

  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i *ngIf="mode == 'create'" class="pi pi-plus-circle mr-1 title-card-icon"></i>
            <i *ngIf="mode == 'edit'" class="pi pi-pencil mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{(mode == 'create' ? 'misc.creation.kpi' : 'misc.edition.kpi') | transloco}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-4 xl:col-3">
    <p-timeline [value]="items" align="left" styleClass="timeline-hidden-opposite lg:pr-2">
      <ng-template pTemplate="marker" let-item>
        <span
          class="custom-marker p-shadow-1"
          [class]="(item.id != items[currentStep].id) ? (items.indexOf(item) < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'"
        >
          <i class="text-white" [ngClass]="(items.indexOf(item) >= currentStep) ? item.icon : 'pi pi-check'"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-item>
        <div class="card flex justify-content-between align-items-center mb-4">
          <h4 [class]="(items.indexOf(item) != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'">
            {{item.label | transloco}}
          </h4>
          <i
            *ngIf="item.description"
            [class]="(items.indexOf(item) != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'"
            [pTooltip]="item.description | transloco"
            tooltipPosition="top"
            class="pi pi-info-circle text-xl"
            tooltipStyleClass="device-info-tooltip"
          ></i>
        </div>
      </ng-template>
    </p-timeline>
  </div>

  <div class="col-12 lg:col-8 xl:col-9" *ngIf="formLoaded">
    <div class="card step-card flex flex-column">

      <div *ngIf="items[currentStep].id === 'info'">
        <app-kpis-form-info
          [kpiInfoForm]="kpiInfoForm"
          [mode]="mode"
          [organizations]="organizations"
          [tenants]="tenants"
          [measurementTypes]="measurementTypes"
          (tenantChange)="onTenantChange($event)"
          (organizationChange)="clearMeasurements()"
        ></app-kpis-form-info>
      </div>

      <div *ngIf="items[currentStep].id === 'filteredMeasurements'">
        <app-kpis-form-filtered-measurements
          [kpiInfoForm]="kpiInfoForm"
          [(filters)]="filters"
          [(enabledFilters)]="enabledFilters"
        ></app-kpis-form-filtered-measurements>
      </div>

      <div *ngIf="items[currentStep].id === 'measurements'">
        <app-kpis-form-measurements
          [(assetMeasurements)]="assetMeasurements"
          [(deviceMeasurements)]="deviceMeasurements"
          [(kpis)]="kpis"
          [kpiInfoForm]="kpiInfoForm"
        ></app-kpis-form-measurements>
      </div>

      <div *ngIf="items[currentStep].id === 'confirmation'">
        <app-kpis-form-confirmation
          [kpiInfoForm]="kpiInfoForm"
          [mode]="mode"
          [filters]="filters"
          [enabledFilters]="enabledFilters"
          [assetMeasurements]="assetMeasurements"
          [deviceMeasurements]="deviceMeasurements"
          [kpis]="kpis"
        ></app-kpis-form-confirmation>
      </div>

      <div class="mt-auto">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
            <button
              *ngIf="currentStep > 0"
              [label]="'common.previous' | transloco"
              (click)="onPreviousStep()"
              pButton
              pRipple
              class="flex-1 sm:flex-none"
              icon="pi pi-angle-left"
              iconPos="left"
            ></button>
            <button
              *ngIf="currentStep < items.length - 1"
              [label]="'common.next' | transloco"
              [disabled]="!kpiInfoForm?.valid"
              (click)="onNextStep()"
              pButton
              pRipple
              class="flex-1 ml-2"
              icon="pi pi-angle-right"
              iconPos="right"
            ></button>
            <button
              *ngIf="currentStep === items.length - 1"
              [label]="(mode == 'create' ? 'common.create' : 'common.save') | transloco"
              [loading]="persistingChanges"
              [disabled]="!kpiInfoForm?.valid"
              (click)="persistKpiData()"
              pButton
              pRipple
              class="p-button-primary ml-2 flex-1 sm:flex-none"
            ></button>
          </div>
          <button
            [label]="'common.cancel' | transloco"
            (click)="onCancel()"
            pButton
            pRipple
            class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
          ></button>
        </div>
      </div>

    </div>
  </div>

</div>
